import { Injectable, signal } from '@angular/core';
const STORAGE_KEY = 'cms-dev-token';
@Injectable({ providedIn: 'root' })
export class CmsDevAuthService {
  private readonly _token = signal<string | null>(this.readFromStorage());
  readonly token = this._token.asReadonly();
  getToken(): string | null {
    return this._token();
  }
  setToken(token: string): void {
    localStorage.setItem(STORAGE_KEY, token);
    this._token.set(token);
  }
  clearToken(): void {
    localStorage.removeItem(STORAGE_KEY);
    this._token.set(null);
  }
  private readFromStorage(): string | null {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }
}
